import { Component } from '@angular/core';
import { AbstractBlModal, ModalSize, ModalButtonType } from '@blcloud/bl-ng-ui-component';

/**
 * 画像の表示コンポーネント
 */
@Component({
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.scss'],
})
export class ImageModalComponent extends AbstractBlModal {

  /** データ */
  data: { src: string[] };

  /** 画像番号 */
  imageNum = 0;

  /** モーダルウィンドウボタンタイプ */
  readonly modalButtonType = ModalButtonType;

  /**
   * コンストラクタ
   */
  constructor(
  ) {
    super();
  }

  // --------------------------------------------------
  // AbstractModal Override

  /**
   * @override
   */
  getResults() {
    return;
  }

  /**
   * @override
   */
  defaultOption() {
    return {
      size: ModalSize.Large,
    };
  }

  onBack() {
    this.imageNum = this.imageNum - 1;
  }

  onNext() {
    this.imageNum = this.imageNum + 1;
  }
}



// WEBPACK FOOTER //
// ./src/app/page/profile-entries-page/image-modal/image-modal.component.ts